@let hotel = hotel$ | async;
<div [editableInStoryblok]="_editable" class="flex flex-col">
	@if (carousel()) {
		<sb-carousel
			[config]="carousel().config"
			[contentMargin]="
				hotelStore.accommodationTypes()?.length > 1 ? 'large' : 'small'
			"
			[items]="carousel().items"
		/>
	}
	<div
		[ngClass]="
			hotelStore.accommodationTypes()?.length > 1 ? '-mt-24' : '-mt-10'
		"
		class="z-10 px-3 md:px-8"
	>
		<div class="section-inner">
			<sb-availability-widget
				[accommodationTypes]="hotelStore.accommodationTypes()"
				[currency]="hotelStore.currency()"
				[hotelGuid]="hotelGUID() || hotel?.guid"
				[hotelSlug]="hotelSlug() || hotel?.slug"
				[language]="currentLanguage()"
				[openAvailabilityInNewTab]="openInNewTab()"
				[showAccommodationTypes]="true"
			/>
		</div>
	</div>
</div>
